import { DeviceStatusEnum, DeviceTypeEnum } from "../enums";

export class DeviceModel{
    plantId: number;
    deviceName: string;
    deviceType: DeviceTypeEnum;
    deviceMacId: string;
    deviceStatus: DeviceStatusEnum;
    lastReportedTime: Date;
    deviceErrorMsg: string;

   /**
    * 
    * @param plantId 
    * @param deviceName 
    * @param deviceType 
    * @param deviceMacId 
    * @param deviceStatus 
    * @param lastReportedTime 
    * @param deviceErrorMsg 
    */
    constructor(plantId: number,deviceName:string,deviceType:DeviceTypeEnum,deviceMacId: string,deviceStatus: DeviceStatusEnum,lastReportedTime: Date,deviceErrorMsg: string){        
        this.plantId = plantId;  
        this.deviceName = deviceName;
        this.deviceType = deviceType;      
        this.deviceMacId = deviceMacId;
        this.deviceStatus = deviceStatus;
        this.lastReportedTime = lastReportedTime;
        this.deviceErrorMsg = deviceErrorMsg;
    }
}